/**
 * @type {Readonly<{DESKTOP: string, MOBILE: string}>}
 */
const RenderModeEnum = Object.freeze({
  DESKTOP: 'desktop',
  MOBILE: 'mobile'
});

export default RenderModeEnum;
